module.exports = require("console");